import { initializeNutasticApp } from '@nutastic/nutastic-react-app';
import { extractElementData, fetchApiData } from '@nutastic/nutastic-react-app/src/utils';
import AppLoading from './components/app/AppLoading';
import App from './components/app/App';
import messages from './i18n/messages';
import WebFont from 'webfontloader';
import AppLinkSite from "./components/app/AppLinkSite";

const init = async () => {
    WebFont.load({
        google: {
            families: [
                'Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,900'
            ]
        }
    });

    const shouldShowLoadingPage = window.location.pathname === '/'; //TODO: put this in react-app
    const hasSiteConfig = window.hasOwnProperty('nutasticSiteConfig');
    const shouldRenderLinkWebsite = hasSiteConfig && window.nutasticSiteConfig.shouldRenderLinkWebsite;

    console.log('initializing page');
    await initializeNutasticApp({
        AppComponent: shouldRenderLinkWebsite ? AppLinkSite : App,
        LoadingComponent: AppLoading,
        initialState: shouldRenderLinkWebsite ? window.nutasticSiteConfig : extractElementData(),
        decorateStateFn: fetchApiData,
        loadingDelay: shouldShowLoadingPage || shouldRenderLinkWebsite ? 1500 : 0,
        messages,
        reducers: []
    });
};

init();
